export enum NotificationType {
  ERROR = 0,
  SUCCESS = 1,
  WARNING = 2
}
